<template>
  <section id="dashboard-ecommerce">
    <b-row class="match-height">
      <b-col xl="6" md="6">
        <DashboardStatistics
          :data="data.statisticsUsers"
          name="User"
        />
      </b-col>
      <b-col xl="6" md="6">
        <DashboardStatistics :data="data.statisticsQuotation" name="Quotations" />
      </b-col>

      <b-col xl="6" md="6">
        <DashboardStatistics :data="data.statisticsInstantQuotation" name="Instant quotation" />
      </b-col>
      <b-col xl="6" md="6">
        <DashboardStatistics :data="data.statisticsBooking" name="Booking" />
      </b-col>

    </b-row>
    <!-- <b-row class="match-height">
      <b-col lg="12">
        <l-map
          :zoom="zoom"
          :center="center"
          style="overflow: hidden !important"
        >
          <l-tile-layer :url="url" />
        </l-map>
      </b-col>
    </b-row> -->
  </section>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";

import { getUserData } from "@/auth/utils";
import DashboardStatistics from "../../components/dashboard/DashboardStatistics.vue";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import axios from "axios";

export default {
  components: {
    BRow,
    BCol,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    DashboardStatistics,
  },
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      zoom: 8,
      center: [47.31322, -1.319482],
      markerLatLng: [47.31322, -1.319482, { draggable: "true" }],
      data: {
        statisticsUsers: [
          {
            icon: "UserXIcon",
            color: "light-info",
            title: "0",
            subtitle: "All",
            customClass: "mb-2 mb-xl-0",
          },
          {
            icon: "UserPlusIcon",
            color: "light-success",
            title: "0",
            subtitle: "Clients",
            customClass: "mb-2 mb-sm-0",
          },
          {
            icon: "UserCheckIcon",
            color: "light-success",
            title: "0",
            subtitle: "Agents",
            customClass: "",
          },
        ],
        statisticsQuotation: [
          {
            icon: "DatabaseIcon",
            color: "light-info",
            title: "0",
            subtitle: "Accepted",
            customClass: "mb-2 mb-xl-0",
          },
          {
            icon: "ClipboardIcon",
            color: "light-success",
            title: "0",
            subtitle: "Refused",
            customClass: "mb-2 mb-sm-0",
          },
          {
            icon: "ClipboardIcon",
            color: "light-success",
            title: "0",
            subtitle: "Waiting",
            customClass: "",
          },
        ],
        statisticsInstantQuotation: [
            {
            icon: "DatabaseIcon",
            color: "light-info",
            title: "0",
            subtitle: "Accepted",
            customClass: "mb-2 mb-xl-0",
          },
          {
            icon: "ClipboardIcon",
            color: "light-success",
            title: "0",
            subtitle: "Refused",
            customClass: "mb-2 mb-sm-0",
          },
          {
            icon: "ClipboardIcon",
            color: "light-success",
            title: "0",
            subtitle: "Waiting",
            customClass: "",
          },
        ],
        statisticsBooking: [
           {
            icon: "ClockIcon",
            color: "light-info",
            title: "0",
            subtitle: "Accepted",
            customClass: "mb-2 mb-xl-0",
          },
          {
            icon: "ClockIcon",
            color: "light-success",
            title: "0",
            subtitle: "Refused",
            customClass: "mb-2 mb-sm-0",
          },
          {
            icon: "ClockIcon",
            color: "light-success",
            title: "0",
            subtitle: "Waiting",
            customClass: "",
          },
        ],
      },
    };
  },
  async created() {
    setTimeout(this.getData(), 500); 
  },
  methods:{
    async getData(){
      const result = await axios.get(
      "https://mtl-feeder-nodejs.onrender.com/api/dashboard"
    );
    const { data } = result;
    this.data.statisticsUsers[0].title =data.customers + data.agents;
    this.data.statisticsUsers[1].title = data.customers;
    this.data.statisticsUsers[2].title = data.agents;
    this.data.statisticsQuotation[0].title = data.acceptedQuotations;
    this.data.statisticsQuotation[1].title = data.refusedQuotations;
    this.data.statisticsQuotation[2].title = data.pendingQuotations;
    this.data.statisticsInstantQuotation[0].title = data.acceptedInstantEstimations;
    this.data.statisticsInstantQuotation[1].title = data.refusedInstantEstimations;
    this.data.statisticsInstantQuotation[2].title = data.pendingInstantEstimations;
    this.data.statisticsBooking[0].title = data.acceptedBookings;
    this.data.statisticsBooking[1].title = data.refusedBookings;
    this.data.statisticsBooking[2].title = data.pendingBookings;
    }
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/dashboard.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
@import "@core/scss/vue/libs/map-leaflet.scss";

.vue2leaflet-map {
  &.leaflet-container {
    height: 550px;
  }
}
.leaflet-image-layer,
.leaflet-layer,
.leaflet-marker-icon,
.leaflet-marker-shadow,
.leaflet-pane,
.leaflet-pane > canvas,
.leaflet-pane > svg,
.leaflet-tile,
.leaflet-tile-container,
.leaflet-zoom-box {
  position: absolute !important;
  top: 0 !important;
}
.leaflet-pane {
  z-index: 400;
}
[dir="ltr"] .leaflet-image-layer,
[dir="ltr"] .leaflet-layer,
[dir="ltr"] .leaflet-marker-icon,
[dir="ltr"] .leaflet-marker-shadow,
[dir="ltr"] .leaflet-pane,
[dir="ltr"] .leaflet-pane > canvas,
[dir="ltr"] .leaflet-pane > svg,
[dir="ltr"] .leaflet-tile,
[dir="ltr"] .leaflet-tile-container,
[dir="ltr"] .leaflet-zoom-box {
  left: 0;
}
</style>